import { render, staticRenderFns } from "./ProductCommentEdit.vue?vue&type=template&id=fa1968fa&scoped=true&"
import script from "./ProductCommentEdit.vue?vue&type=script&lang=js&"
export * from "./ProductCommentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa1968fa",
  null
  
)

export default component.exports